// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".list-module__container--zUnpX{color:#303030;font-weight:400;font-size:14px;line-height:21px;letter-spacing:0}.list-module__key--3BuXM{display:inline;color:#616161}.list-module__value--3M3ch{display:inline;color:#303030;font-weight:500;font-size:14px;line-height:21px;letter-spacing:0}\n", ""]);
// Exports
exports.locals = {
	"container": "list-module__container--zUnpX",
	"key": "list-module__key--3BuXM",
	"value": "list-module__value--3M3ch"
};
module.exports = exports;
